"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomAnimatedParticle = void 0;
var _pixi = require("pixi.js");
var _pixiParticles = require("pixi-particles");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * An individual particle image with an animation. Art data passed to the emitter must be
 * formatted in a particular way for AnimatedParticle to be able to handle it:
 *
 * ```typescript
 * {
 *     //framerate is required. It is the animation speed of the particle in frames per
 *     //second.
 *     //A value of "matchLife" causes the animation to match the lifetime of an individual
 *     //particle, instead of at a constant framerate. This causes the animation to play
 *     //through one time, completing when the particle expires.
 *     framerate: 6,
 *     //loop is optional, and defaults to false.
 *     loop: true,
 *     //textures is required, and can be an array of any (non-zero) length.
 *     textures: [
 *         //each entry represents a single texture that should be used for one or more
 *         //frames. Any strings will be converted to Textures with Texture.fromImage().
 *         //Instances of PIXI.Texture will be used directly.
 *         "animFrame1.png",
 *         //entries can be an object with a 'count' property, telling AnimatedParticle to
 *         //use that texture for 'count' frames sequentially.
 *         {
 *             texture: "animFrame2.png",
 *             count: 3
 *         },
 *         "animFrame3.png"
 *     ]
 * }
 * ```
 */
var CustomAnimatedParticle = exports.CustomAnimatedParticle = /*#__PURE__*/function (_Particle) {
  /**
   * @param emitter The emitter that controls this AnimatedParticle.
   */
  function CustomAnimatedParticle(emitter) {
    var _this;
    _classCallCheck(this, CustomAnimatedParticle);
    _this = _callSuper(this, CustomAnimatedParticle, [emitter]);
    /**
     * Texture array used as each frame of animation, similarly to how MovieClip works.
     */
    _defineProperty(_this, "textures", void 0);
    /**
     * Duration of the animation, in seconds.
     */
    _defineProperty(_this, "duration", void 0);
    /**
     * Animation framerate, in frames per second.
     */
    _defineProperty(_this, "framerate", void 0);
    /**
     * Animation time elapsed, in seconds.
     */
    _defineProperty(_this, "elapsed", void 0);
    /**
     * If this particle animation should loop.
     */
    _defineProperty(_this, "loop", void 0);
    _this.textures = null;
    _this.duration = 0;
    _this.framerate = 0;
    _this.elapsed = 0;
    _this.loop = false;
    return _this;
  }

  /**
   * Initializes the particle for use, based on the properties that have to
   * have been set already on the particle.
   */
  _inherits(CustomAnimatedParticle, _Particle);
  return _createClass(CustomAnimatedParticle, [{
    key: "init",
    value: function init() {
      this.Particle_init();
      this.elapsed = 0;

      //if the animation needs to match the particle's life, then cacluate variables
      if (this.framerate < 0) {
        this.duration = this.maxLife;
        this.framerate = this.textures.length / this.duration;
      }
    }

    /**
     * Sets the textures for the particle.
     * @param art An array of PIXI.Texture objects for this animated particle.
     */
  }, {
    key: "applyArt",
    value: function applyArt(art) {
      this.textures = art.textures;
      this.framerate = art.framerate;
      this.duration = art.duration;
      this.loop = art.loop;
    }

    /**
     * Updates the particle.
     * @param delta Time elapsed since the previous frame, in __seconds__.
     */
  }, {
    key: "update",
    value: function update(delta) {
      var lerp = this.Particle_update(delta);
      //only animate the particle if it is still alive
      if (lerp >= 0) {
        this.elapsed += delta;
        if (this.elapsed > this.duration) {
          //loop elapsed back around
          if (this.loop) this.elapsed = this.elapsed % this.duration;
          //subtract a small amount to prevent attempting to go past the end of the animation
          else this.elapsed = this.duration - 0.000001;
        }
        // add a very small number to the frame and then floor it to avoid
        // the frame being one short due to floating point errors.
        var frame = this.elapsed * this.framerate + 0.0000001 | 0;
        this.texture = this.textures[frame] || _pixi.Texture.EMPTY;
      }
      return lerp;
    }

    /**
     * Destroys the particle, removing references and preventing future use.
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.Particle_destroy();
      this.textures = null;
    }

    /**
     * Checks over the art that was passed to the Emitter's init() function, to do any special
     * modifications to prepare it ahead of time.
     * @param art The array of art data, properly formatted for AnimatedParticle.
     * @return The art, after any needed modifications.
     */
  }], [{
    key: "parseArt",
    value: function parseArt(art) {
      var data, output, textures, tex, outTextures;
      var outArr = [];
      for (var i = 0; i < art.length; ++i) {
        data = art[i];
        outArr[i] = output = {};
        output.textures = outTextures = [];
        textures = data.textures;
        for (var j = 0; j < textures.length; ++j) {
          tex = textures[j];
          if (typeof tex == "string") outTextures.push(_pixi.Texture.from(tex));else if (tex instanceof _pixi.Texture) outTextures.push(tex);
          //assume an object with extra data determining duplicate frame data
          else {
            var dupe = tex.count || 1;
            if (typeof tex.texture == "string") tex = _pixi.Texture.from(tex.texture);else
              // if(tex.texture instanceof Texture)
              tex = tex.texture;
            for (; dupe > 0; --dupe) {
              outTextures.push(tex);
            }
          }
        }

        //use these values to signify that the animation should match the particle life time.
        if (data.framerate == "matchLife") {
          //-1 means that it should be calculated
          output.framerate = -1;
          output.duration = 0;
          output.loop = false;
        } else {
          //determine if the animation should loop
          output.loop = !!data.loop;
          //get the framerate, default to 60
          output.framerate = data.framerate > 0 ? data.framerate : 60;
          //determine the duration
          output.duration = outTextures.length / output.framerate;
        }
      }
      return outArr;
    }
  }]);
}(_pixiParticles.Particle);
//# sourceMappingURL=CustomAnimatedParticle.js.map